import React, { useEffect, useState } from "react";
import "../../styles/Company.css";
import finalvid from "../../assests/finalvid.mp4";
import ProjectCard from "./ProjectCard";
import TypingText from "./TypingText";
import { motion } from "framer-motion";

const cardVariants = {
  hidden: { opacity: 0, y: 50 },
  visible: (i) => ({
    opacity: 1,
    y: 0,
    transition: {
      delay: i * 0.2, // تأخير بسيط بين كل كارد والتاني
      duration: 0.6,
      ease: "easeOut",
    },
  }),
};

const Company = () => {
  const [projects, setProjects] = useState([]);

  useEffect(() => {
    fetch(
      "https://opensheet.elk.sh/1zCLqWca65lw5zKoQIWo3OybO5Aw362OzIqWQvDkgAfA/projects"
    )
      .then((res) => res.json())
      .then((data) => {
        console.log("Fetched Data:", data); // تأكدي من الداتا اللي جايه
        const cleanData = data.filter((item) => item.name && item.image);
        setProjects(cleanData);
      })
      .catch((err) => console.error("Error fetching data:", err));
  }, []);

  return (
    <div className="bg-white">
      <div className="bg-gradient-to-r from-[#201C59] to-indigo-700 text-white py-24 px-6 md:px-20 text-center rounded-b-[70px] shadow-lg">
          <motion.h1
            initial={{ opacity: 0, y: -30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
            className="text-5xl font-bold mb-6"
          >
            DTEC's Projects Since  <span className="text-yellow-400">1996</span>
          </motion.h1>
        </div>
      <div className="container items-center ">
        {/* <div className="p-3">
          <TypingText text="DTEC's Projects Since 1996" speed={120} />
        </div> */}
        

        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6 mt-10 items-stretch mb-4">
          {projects.map((p, i) => (
            <motion.div
              key={i}
              custom={i}
              initial="hidden"
              animate="visible"
              variants={cardVariants}
              className="flex" // علشان الكارد يتمدد
            >
              <ProjectCard
                image={p.image}
                title={p.name}
                client={p.client}
                consultant={p.consultant}
                scope={p["scope_of_work"]}
                status={p.status}
                details={p.details} // << أضف دي
              />
            </motion.div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Company;
